if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',
    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          enabled: 'mobile-sticky-bar-enabled',
          isShow: 'mobile-sticky-bar-up',
          isHide: 'mobile-sticky-bar-down',
        };

        this.compareToggleUnsubscriber = FoxTheme.pubsub.subscribe('compare:toggle', this.onCompareToggle.bind(this));
      }

      compareToggleUnsubscriber = undefined;

      connectedCallback() {
        document.body.classList.add(this.classes.enabled);
        if (this.isCompareBarShowing()) {
          this.hide();
        } else {
          this.show();
        }

        this.init();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.resizeHandler);

        if (this.compareToggleUnsubscriber) {
          this.compareToggleUnsubscriber();
        }
      }

      init() {
        this.calculateHeight();
        this.resizeHandler = this.calculateHeight.bind(this);
        window.addEventListener('resize', this.resizeHandler, { passive: true });
        this.bindSearchTriggers();
      }

      bindSearchTriggers() {
        this.querySelectorAll('[data-sticky-search]').forEach((button) => {
          button.addEventListener('click', this.openSearch.bind(this));
        });
      }

      openSearch(event) {
        event.preventDefault();

        const input = document.querySelector('header predictive-search input[type="search"], header .search__input');
        if (!input) {
          window.location.href = window.FoxTheme?.routes?.search_url || '/search';
          return;
        }

        document.body.classList.add('header-pinned');

        if (window.scrollY > 0) {
          window.scrollTo(0, 0);
        }

        // Focus in the same turn as the tap so iOS/Android open the keyboard.
        input.focus();
      }

      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        });
      }

      isCompareBarShowing() {
        return document.body.classList.contains('is-product-comparing');
      }

      onCompareToggle(event) {
        if (event.isActive) {
          this.hide();
        } else {
          this.show();
        }
      }

      show() {
        document.body.classList.remove(this.classes.isHide);
        document.body.classList.add(this.classes.isShow);
      }

      hide() {
        document.body.classList.remove(this.classes.isShow);
        document.body.classList.add(this.classes.isHide);
      }
    }
  );
}
